import fp from 'lodash/fp';
import { all } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga/effects';

export const mapSagasFromConfigurations = (moduleName) => (configurations) => all(
  fp.flow(
    fp.filter(
      ({ sagas }) => sagas
    ),
    fp.map(
      ({ name, sagas, action }) => {
        return takeLatest(action[moduleName][name]().type, sagas)
      }
    )
  )(configurations)
)

/**
 * for actions not following the standard format
 * we put the linking logic in the configuration file and simple combine them here
 */
export const combineConfigurationSagas = fp.flow(
  fp.filter('sagas'),
  fp.map('sagas')
)


// WEBPACK FOOTER //
// ./src/state/helpers/sagas.js